import React, { useState, useEffect }  from 'react';
import Style from '../styles/pages/BookingOptions.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { Booking } from '../utils/Interface';
import { RootState } from '../store/GlobalStore'
import PageHeader from '../components/layout/PageHeader'
import plus from '../shared/images/Icon awesome-plus-square.svg'
import { useTranslation } from 'react-i18next';
import { Box, Typography, List, ListItem } from '@mui/material'
const BookingOptions: React.FC = () => {
    const { asterioId } = useParams<{ asterioId: string }>();
    const { t, i18n  } = useTranslation();
    const authState = useSelector((state: RootState) => state.Auth)

    // Fonction pour regrouper les folios par productCode
    const groupFoliosByProductCode = (folios: any[]) => {
        const grouped: Record<string, any> = {};

        folios.forEach((folio) => {
            const { productCode, label, quantity, unitPrice, total } = folio;

            if (!grouped[productCode]) {
                grouped[productCode] = {
                    productCode,
                    label,
                    unitPrice,
                    totalQuantity: 0,
                    totalPrice: 0,
                };
            }

            // Ajouter les valeurs à chaque groupe
            grouped[productCode].totalQuantity += quantity;
            grouped[productCode].totalPrice += total;
        });

        return Object.values(grouped);
    };

    // Obtenez et regroupez les folios
    const folios = authState?.reservations?.[0]?.Folios || [];
    const groupedFolios = groupFoliosByProductCode(folios);

    return (
        <div className={Style.AnimationContainer}>
            <PageHeader backTo='/all-reservations' />
            <form className={Style.ModifyLesseeForm}>
                <div className={`${Style.ModifyLesseeFormChild}`}>
                    <div className={`${Style.DesktopFormField} ${Style.Resa}`}>
                        <div className={`${Style.InputContainer} ${Style.ResaNumber}`}>
                            <div className={Style.Label}>{t('resa_num')}</div>
                            <div className={Style.Data}>{asterioId}</div>
                        </div>
                        <div className={`${Style.InputContainer} ${Style.KeyCode}`}>
                            <div className={Style.Label}>{t('key_code')}</div>
                            <div className={Style.Data}>-</div>
                        </div>
                    </div>
                    <div className={Style.DesktopFormField}>
                        <div className={Style.InputContainer}>
                            <div className={Style.Label}>
                                <img
                                    src={plus}
                                    alt='plus'
                                    className={Style.AccountIcon}
                                />
                                {t('prestas')}
                            </div>
                            {groupedFolios.map((folio, index) => (
                                <div key={index} className={Style.FolioEntry}>
                                    {folio.totalQuantity} x {folio.label} ({folio.unitPrice}€) = {folio.totalPrice}€
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default BookingOptions
